<template>
  <b-tabs content-class="p-3 tab-body">
    <b-tab title="Algemeen" active>
      <ValidationProvider rules="required" v-slot="{ errors }">
        <div class="mb-3">
          <label class="required">Type ticket</label>
          <b-form-select v-model="ticket.type" :options="ticketTypeOptions" />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </ValidationProvider>

      <ValidationProvider rules="required" v-slot="{ errors }">
        <div class="mb-3">
          <label class="required">Naam ticket</label>
          <b-form-input v-model="ticket.name" />
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </ValidationProvider>

      <div class="mb-3">
        <label>Beschrijving</label>
        <b-form-textarea v-model="ticket.description" />
      </div>

      <div class="mb-3">
        <label>Prijs</label>
        <b-form-input
          v-money="money"
          v-model="ticket.price"
          min="0"
          placeholder="0.00"
        />
      </div>

      <div class="mb-3">
        <label>Aantal beschikbare tickets</label>
        <b-form-input
          v-model="ticket.amount_available"
          v-mask="'#########'"
          placeholder="Onbeperkt"
          min="0"
        />
      </div>

      <ValidationProvider rules="max:1000" v-slot="{ errors }">
        <div class="mb-3">
          <label>Extra Informatie</label>
          <VueTrix v-model="ticket.extra_information" />
          <p class="text-muted mb-1">
            Bijvoorbeeld: Informatie over toegangsbeleid of overige
            toevoegingen.
          </p>
          <div v-if="errors.length" class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </div>
      </ValidationProvider>
    </b-tab>

    <b-tab title="Afbeelding">
      <div class="mb-3">
        <label>Upload een afbeelding voor op je ticket</label>
        <p class="text-muted">Optimaal formaat: 2200x2500px (max. 5MB)</p>
        <DropFile v-model="ticket.header_image" accept="image/png,image/jpeg" />
      </div>
    </b-tab>
    <b-tab title="Verkoopdatum">
      <div class="mb-3">
        <label>Gelijk aan evenement</label>
        <b-form-select
          v-model="ticket.is_custom_sell_date"
          :options="customSaleDateOptions"
        />
      </div>
      <template v-if="ticket.is_custom_sell_date">
        <b-row>
          <b-col lg="6" class="mb-3">
            <label class="required">Startdatum</label>
            <b-row>
              <b-col cols="8">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Datum</p>
                    <b-form-input
                      v-model="ticket.start_sale_at_date"
                      type="date"
                      max="9999-12-31"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col cols="4">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Tijd</p>
                    <b-form-input
                      v-model="ticket.start_sale_at_time"
                      type="time"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6" class="mb-3">
            <label class="required">Einddatum</label>
            <b-row>
              <b-col cols="8">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Datum</p>
                    <b-form-input
                      v-model="ticket.end_sale_at_date"
                      type="date"
                      max="9999-12-31"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col cols="4">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Tijd</p>
                    <b-form-input
                      v-model="ticket.end_sale_at_time"
                      type="time"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </b-tab>
    <b-tab title="Geldigheidsdatum">
      <template v-if="event.type == 'multiple'">
        <div class="mb-3">
          <label>Meerdaagse ticket</label>
          <p class="text-muted mb-0">
            Deze ticket mag elke dag gebruikt worden.
          </p>
          <b-form-select
            v-model="ticket.is_multiday_ticket"
            :options="yesNoOptions"
          />
        </div>
      </template>
      <div class="mb-3">
        <label>Gelijk aan evenement</label>
        <b-form-select
          v-model="ticket.is_custom_valid_date"
          :options="customValidDateOptions"
        />
      </div>
      <template v-if="ticket.is_custom_valid_date">
        <b-row>
          <b-col lg="6" class="mb-3">
            <label class="required">Startdatum</label>
            <b-row>
              <b-col cols="8">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Datum</p>
                    <b-form-input
                      v-model="ticket.start_valid_at_date"
                      type="date"
                      max="9999-12-31"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col cols="4">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Tijd</p>
                    <b-form-input
                      v-model="ticket.start_valid_at_time"
                      type="time"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6" class="mb-3">
            <label class="required">Einddatum</label>
            <b-row>
              <b-col cols="8">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Datum</p>
                    <b-form-input
                      v-model="ticket.end_valid_at_date"
                      type="date"
                      max="9999-12-31"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
              <b-col cols="4">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="mb-3">
                    <p class="text-muted mb-0">Tijd</p>
                    <b-form-input
                      v-model="ticket.end_valid_at_time"
                      type="time"
                    />
                    <div v-if="errors.length" class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { VMoney } from "v-money";
import VueTrix from "vue-trix";

import DropFile from "@/components/DropFile.vue";

export default {
  components: {
    ValidationProvider,
    VueTrix,
    DropFile,
  },
  props: {
    event: Object,
    ticket: Object,
  },
  directives: {
    money: VMoney,
  },
  data() {
    return {
      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      ticketTypeOptions: [
        { text: "Selecteer een optie", value: null },
        { text: "Toegangsticket", value: "ticket" },
        { text: "Voucher", value: "voucher" },
      ],
      customSaleDateOptions: [
        { text: "Ja", value: false },
        { text: "Nee", value: true },
      ],
      customValidDateOptions: [
        { text: "Ja", value: false },
        { text: "Nee", value: true },
      ],
      yesNoOptions: [
        { text: "Ja", value: true },
        { text: "Nee", value: false },
      ],
    };
  },
  methods: {},
};
</script>
